export default __webpack_public_path__ + "static/media/ElenaArmoredNavigator.ce9378fa.pdf";